export const readActionFunnelStage = data => {
  try {
    const settings = typeof data === 'string' ? JSON.parse(data) : data;
    return settings?.funnelStage && typeof settings.funnelStage.label === 'string'
      ? settings.funnelStage : null;
  } catch {
    return null;
  }
};

export const sameFunnelStage = (left, right) => JSON.stringify(left || null) === JSON.stringify(right || null);

export const canSuggestActionFunnel = actions => {
  let hasItemAction = false;
  for (const action of actions) {
    try {
      const raw = action.customData ?? action.data;
      const data = typeof raw === 'string' ? JSON.parse(raw || '{}') : raw || {};
      if (!data || typeof data !== 'object' || Array.isArray(data)
        || data.funnelStage || data.funnelStageDisabled) return false;
      if (action.scope !== 'project') hasItemAction = true;
    } catch {
      return false;
    }
  }
  return hasItemAction;
};
